import { InvitationService } from './invitations/Invitation.service'
import { Firestore } from 'firebase/firestore'

export class ServiceFactory {
	invitationService: InvitationService
	constructor(db: Firestore) {
		this.invitationService = new InvitationService(db)
	}
}
